



































































import { Component, Ref, Vue, Emit, Prop, Watch } from 'vue-property-decorator';
@Component
export default class HelloWord extends Vue {
  @Prop(Object) detailInfo;
  @Prop({ default: () => ({}) }) dateTime: any; //倒计时数据
}
